export const MOTION_EASING = [0.22, 1, 0.36, 1] as const;

export const MOTION_DURATION = {
  fast: 0.35,
  normal: 0.45,
  slow: 0.55,
} as const;

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function setMotionHidden(el: HTMLElement, y = 16) {
  el.style.opacity = '0';
  el.style.transform = `translateY(${y}px)`;
}

export function clearMotionInline(el: HTMLElement) {
  el.style.opacity = '';
  el.style.transform = '';
}
